<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("mp:application.result.title") }}
    </p>
    <p class="mb-5">{{ $t("mp:application.result.subtitle") }}</p>

    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("mp:application.result.success.title") }}
    </p>
    <p class="mb-5">{{ $t("mp:application.result.success.subtitle") }}</p>
    <application-template
      template="MERCHANT_APPLICATION_SUCCESS"
    ></application-template>

    <b-field class="mt-6">
      <b-button
        type="is-success"
        size="is-large"
        :label="$t('mp:application.result.button.finish')"
        :rounded="true"
        :inverted="true"
        icon-left="check"
        @click="finishApplication"
      ></b-button>
    </b-field>
  </div>
</template>

<script>
import { USER_STATUS } from "../../utils/const";

export default {
  name: "ApplicationFlowResult",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  components: {
    ApplicationTemplate: () =>
      import("@/components/application/ApplicationTemplate.vue"),
  },
  methods: {
    async finishApplication() {
      try {
        await this.$store.dispatch("application/finish");

        await this.$store.dispatch(
          "profile/updateStatusLocal",
          USER_STATUS.COMPLETED
        );

        await this.$router.push("/profile");
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
